import { Injectable } from '@angular/core';
import { DatabaseService } from '@core/database';
import { AlertController, NavController } from '@ionic/angular';
import { DATABASE_COLLECTIONS } from '@library/core-models/src/schema';
import { FormModel } from '@core/models';
import { AppSettings } from '@library/plugin-settings/src/public_api';
import moment from 'moment';
import { DeviceNotificationService } from '@library/plugin-device-notification/src/public_api';

@Injectable({ providedIn: 'root' })
export class FormService {
    constructor(
        private databaseService: DatabaseService,
        private navController: NavController,
        private settings: AppSettings,
        private notificationService: DeviceNotificationService
    ) {}

    async notifyForm(form: FormModel) {
        this.navController.navigateForward(`/form/${form.key}`);
    }

    async check() {
        const db = await this.databaseService.databaseAwaiter();
        const collection = db.use<FormModel>(DATABASE_COLLECTIONS.FormCollection);
        const forms = (await collection.find().exec()).map((x) => x.toJSON()).filter((x) => !x.done);
        if (forms.length === 0) return;

        const form = forms[0];
        await this.notifyForm(form);
    }

    async createFormNotifications() {
        const db = await this.databaseService.databaseAwaiter();
        const collection = db.use<FormModel>(DATABASE_COLLECTIONS.FormCollection);

        let surveys = (await collection.find().exec()).map(x => x.toJSON());

        if (surveys.length) {
            let aftercareStartDate = this.settings.get('aftercare-start-date')
                ? moment(this.settings.get('aftercare-start-date'))
                : moment.unix(this.settings.get('init-timestamp'));
            const availableDate = moment(aftercareStartDate).startOf('day');

            const allNotifications = await this.notificationService.getPending();
            const notificationTime = '17:00'.split(':');
            const createdNotifications = allNotifications.filter((n) => n.title === 'MiA Fragebogen');

            if (createdNotifications && createdNotifications.length) {
                for (let i = 0; i < createdNotifications.length; i++) {
                    let entry = createdNotifications[i];
                    try {
                        await this.notificationService.remove(entry.id);
                    } catch (err) {}
                }
            }

            let surveysNotDone = false;

            const surveyMap = new Map<string, number>();
            surveyMap.set('survey-1', 0);
            surveyMap.set('survey-2', 0);
            surveyMap.set('survey-3', 0);
            surveyMap.set('survey-4', 12);
            surveyMap.set('survey-5', 12);
            surveyMap.set('survey-6', 12);

            let nextSurveyStartDate;
            for (const survey of surveys) {
                const surveyDateOffset = surveyMap.get(survey.key);
                const check = moment(availableDate).add(surveyDateOffset, 'weeks').isBefore(moment());

                if (!survey.doneDate && check) {
                    surveysNotDone = true;
                    nextSurveyStartDate = moment(availableDate).add(surveyDateOffset, 'weeks');

                    console.log('----------------------- next survey date >', nextSurveyStartDate.toISOString())
                    break;
                }
            }

            if (surveysNotDone) {
                for (let i = 0; i < 15; i++) {
                    const date = moment(nextSurveyStartDate)
                    .add(i, 'days')
                    .set('hour', +notificationTime[0])
                    .set('minutes', +notificationTime[1]);
                    console.log('----------------------- next survey notification date >', date.toISOString())
                    this.notificationService.schedule('MiA Fragebogen', 'Ein neuer Fragebogen wurde freigeschaltet. Du kannst ihn ab sofort über das Menü ausfüllen.', true, date);
                }
            }

        }
    }
}

